import { render, staticRenderFns } from "./EditCourseFaculty.vue?vue&type=template&id=74f40e78&scoped=true&"
import script from "./EditCourseFaculty.vue?vue&type=script&lang=js&"
export * from "./EditCourseFaculty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f40e78",
  null
  
)

export default component.exports